import { ajax } from "@/utils/request";

export default {
    /****************************************************************
     *
     *@月度检查配置 projectConf
     *
     ***************************************************************/

    addProjectConf: (data: any) => {
        return ajax({
            method: 'POST',
            url: `check-config-mgt/check`,
            data
        })
    },

    // 获取检查配置项
    getProjectConf: (id: any) => {
        return ajax({
            method: 'GET',
            url: `check-config-mgt/check/${id}`,
        })
    },

    // 修改
    editProjectConf: (data: any) => {
        return ajax({
            method: 'PUT',
            url: `check-config-mgt/check/${data.id}`,
            data
        })
    },

    // 移除
    removeProjectConf: (id: any) => {
        return ajax({
            method: 'DELETE',
            url: `check-config-mgt/check/${id}`,
        })
    },

    getProjectConfList: (data: any) => {
        return ajax({
            method: 'GET',
            url: `check-config-mgt/list`,
            data
        })
    },

    // 修改title 名称
    editProjectConfTitle: (data: any) => {
        return ajax({
            method: 'PUT',
            url: `check-config-mgt/update-title/${data.id}?title=${data.title}&weight=${data.weight}`,

        })
    },

    // 强节点分页 /strong-node-check-config-mgt/list
    getStrongNode: (data: any) => {
        return ajax({
            method: 'get',
            url: `strong-node-check-config-mgt/list`,
            data
        })
    },

    // 新增强节点
    addStrongNode: (data: any) => {
        return ajax({
            method: 'post',
            url: `strong-node-check-config-mgt/config`,
            data
        })
    },

    // 修改强节点
    editStrongNode: (data: any) => {
        return ajax({
            method: 'put',
            url: `strong-node-check-config-mgt/config/${data.id}`,
            data
        })
    },

    // 强节点明细
    getStrongNodeDetail: (id: number) => {
        return ajax({
            method: 'get',
            url: `strong-node-check-config-mgt/config/${id}`,
        })
    },

    // 移除
    removeMonthCheck: (id: any) => {
        return ajax({
            method: 'DELETE',
            url: `check-mgt/check/${id}`,
        })
    },

    // 月度检查表列表
    getMonthCheck: (data: any) => {
        return ajax({
            method: 'GET',
            url: `check-mgt/list`,
            data
        })
    },

    // 新增月度检查表
    addMonthCheck: (data: any) => {
        return ajax({
            method: 'POST',
            url: `check-mgt/check`,
            data
        })
    },

    // 获取月度检查表明细
    getMonthCheckDetail: (id: any) => {
        return ajax({
            method: 'GET',
            url: `check-mgt/check/${id}`,
        })
    },

    // 修改月度检查表 check-mgt/check/{id}
    editMonthCheck(data: any) {
        return ajax({
            method: 'PUT',
            url: `check-mgt/check/${data.id}`,
            data
        })
    },

    // 月度质安考评排名
    getMonthRank(monthNo: any) {
        return ajax({
            method: 'GET',
            url: `check-project-mgt/rank?monthNo=${monthNo}`,
        })
    },

    // 获取月度检查项目综合评分 
    getMonthProjectCheckDetail(data: any) {
        return ajax({
            method: 'GET',
            url: `check-project-mgt/check`,
            data
        })
    },

    // 修改月度检查项目综合评分 
    editMonthProjectCheckDetail(data: any) {
        return ajax({
            method: 'PUT',
            url: `check-project-mgt/check/${data.id}`,
            data
        })
    },

    // 保存月度检查项目综合评分 
    addMonthProjectCheckDetail(data: any) {
        return ajax({
            method: 'POST',
            url: `check-project-mgt/check`,
            data
        })
    },
    /****************************************************************
     *
     *@交流学习、优秀案例 projectConf
     *
     ***************************************************************/
    // 交流学习、优秀案例分页
    studyAndCaseList(data: any) {
        return ajax({
            method: 'get',
            url: `study-mgt/study`,
            data
        })
    },
    // 交流学习、优秀案例新增
    studyAndCaseAdd(data: any) {
        return ajax({
            method: 'post',
            url: `study-mgt/study`,
            data
        })
    },
    // 交流学习、优秀案例修改s
    studyAndCaseUpdate(id: any, data: any) {
        return ajax({
            method: 'put',
            url: `study-mgt/study/${id}`,
            data
        })
    },
    // 交流学习、优秀案例详情
    studyAndCaseDetail(id: any) {
        return ajax({
            method: 'get',
            url: `study-mgt/study/${id}`
        })
    },
    // 交流学习、优秀案例移除
    studyAndCaseDele(id: any) {
        return ajax({
            method: 'delete',
            url: `study-mgt/study/${id}`
        })
    },
    // 交流学习、优秀案例发布
    studyAndCasePublish(id: any) {
        return ajax({
            method: 'put',
            url: `study-mgt/publish/${id}`
        })
    },
    // 交流学习、优秀案例撤回
    studyAndCaseCancel(id: any) {
        return ajax({
            method: 'put',
            url: `study-mgt/cancel/${id}`
        })
    },


    // 强管节点检查管理分页
    getStrongNodePage: (data: any) => {
        return ajax({
            method: 'get',
            url: `strong-node-check-mgt/check`,
            data
        })
    },

    // 获取强管节点检查管理 
    getStrongNodeCheck: (id: any) => {
        return ajax({
            method: 'get',
            url: `strong-node-check-mgt/check/${id}`,
        })
    },

    // 评分 强管节点检查评分
    setCheckJudge(data: any) {
        return ajax({
            method: 'PUT',
            url: `strong-node-check-mgt/check-judge/${data.id}`,
            data
        })
    },

    // 移除强管节点检查配置 
    removeStrongCheck(id: any) {
        return ajax({
            method: 'DELETE',
            url: `strong-node-check-config-mgt/config/${id}`,
        })
    }

};


